
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 18.8v-5.95h-1.6v5.95H5.6V5.2h5.6V3.5H5.6c-.884 0-1.6.761-1.6 1.7v13.6c0 .939.716 1.7 1.6 1.7h12.8c.884 0 1.6-.761 1.6-1.7zM17.742 4.115A1.903 1.903 0 0016.35 3.5c-.523 0-1.025.222-1.394.616l-6.695 7.113c-.598.56-.99 1.394-1.058 2.29L7.2 16.252v.85h3.308a3.173 3.173 0 002.258-1.172l6.657-7.07c.369-.392.577-.925.577-1.48a2.16 2.16 0 00-.577-1.479l-1.681-1.786zm-7.291 11.289c.428-.032.825-.243 1.145-.632l4.849-5.152-2.203-2.342-4.885 5.189a1.8 1.8 0 00-.557 1.121v1.814l1.651.002zm4.922-9.327l2.204 2.341.715-.76a.408.408 0 000-.555l-1.683-1.788a.354.354 0 00-.259-.115.352.352 0 00-.259.115l-.718.762z"}})])
          )
        }
      }
    